import { ChannelWithPosiiton } from 'planby/dist/Epg/helpers/types'
import { getPlacement } from '../../helpers'
import { getLinkUrlFromSport } from '../../helpers/sportsUrlData'
import {
    StyledChannelBox,
    StyledChannelLink,
    StyledChannelLogo,
    StyledInnerChannelBox,
} from './ChannelIcon.styled'

type ChannelIconProps = {
    channel: ChannelWithPosiiton
}

const getPictogramFromSportCode = (code: string) => {
    const aliases: Record<string, string> = {
        // Legacy basketball code maps to current pictogram file.
        BB: 'BK3',
        // PWL shares icon with WLF by design.
        PWL: 'WLF',
        // Keep support for legacy road cycling codes with shared pictogram.
        CRD0701: 'CRD',
        CRD1002: 'CRD',
    }

    const normalizedCode = (aliases[code] || code).toLowerCase()

    try {
        return require(`./Icons/${normalizedCode}.png`)
    } catch {
        try {
            return require('./Icons/cer.png')
        } catch {
            return null
        }
    }
}

export const ChannelIcon = ({ channel }: ChannelIconProps) => {
    const { position, logo, uuid, color } = channel

    return (
        <StyledChannelBox {...position}>
            <StyledChannelLink
                href={getLinkUrlFromSport(uuid, getPlacement())}
                target="_blank"
                rel="noopener noreferrer"
            >
                <StyledInnerChannelBox color={color} placement={getPlacement()}>
                    <StyledChannelLogo src={getPictogramFromSportCode(uuid) || logo} alt="Logo" />
                </StyledInnerChannelBox>
            </StyledChannelLink>
        </StyledChannelBox>
    )
}
